import { FC, ReactNode } from 'react';
import { Root } from './styled';

type Props = {
  children?: ReactNode;
};

const Card: FC<Props> = ({ children }) => {
  return <Root>{children}</Root>;
};

export default Card;
